import * as React from 'react';
import { ToneOptionComponentProps, ToneOptionComponentHandler } from './toneoptioncomponent';
import { ToneOptionCSSStyle } from './toneoptioncss';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { BuyToneComponent } from '../../popup/buytone/buytonecomponent';
import { GiftAFriendComponent } from '../../popup/giftafriend/giftafriendcomponent';
import { ShareToneComponent } from '../../popup/sharetone/sharetonecomponent';
import { TellAFriendComponent } from '../../popup/tellafriend/tellafriendcomponent';
import { Strings } from '../../../../utils/resources/strings';
import { ToneOptionCardComponent } from './toneoptioncard/toneoptioncardcomponent';


export class ToneOptionViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private popUpComponent: PopUpWrapperComponent;
    
    bindHandlers()
    {
        this.onBuyToneClicked = this.onBuyToneClicked.bind(this);
        this.onGiftToneClicked = this.onGiftToneClicked.bind(this);
        this.onShareToneClicked = this.onShareToneClicked.bind(this);
        this.onAddToWishlistClicked = this.onAddToWishlistClicked.bind(this);
        this.onReferToneClicked = this.onReferToneClicked.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    draw(props: ToneOptionComponentProps, state: UIComponentState, cssStyle: ToneOptionCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
           <div style={cssStyle.getWrapperCSSStyle()}>
                {props.tonePrivilage.isAddWishlist() && <div onClick={this.onAddToWishlistClicked} style={cssStyle.getCardListDivCSSStyle()}>
                    <ToneOptionCardComponent iconName={"settone.svg"} context={this.getContext()} title={props.context.getResources().getString(Strings.wishlist)}/>  
                </div>}
                <div onClick={this.onReferToneClicked} style={cssStyle.getCardListDivCSSStyle()}>
                    <ToneOptionCardComponent iconName={"announce_grey.svg"} context={this.getContext()} title={props.context.getResources().getString(Strings.tellafriend)}/>  
                 </div>
                 <div onClick={this.onGiftToneClicked} style={cssStyle.getCardListDivCSSStyle()}>
                    <ToneOptionCardComponent iconName={"gift_grey.svg"} context={this.getContext()} title={props.context.getResources().getString(Strings.gift)}/>  
                 </div>
                 <div onClick={this.onShareToneClicked} style={cssStyle.getCardListDivCSSStyle()}>
                    <ToneOptionCardComponent iconName={"share_grey.svg"} context={this.getContext()} title={props.context.getResources().getString(Strings.share)}/>  
                 </div>
                 <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
           </div>
        );
    }

    onBuyToneClicked(): void 
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
        <BuyToneComponent showPopupOption={()=>''} getPopupWrapper={()=>''} showPopup={()=>""} toneOptionsType={(this.getUIProps() as ToneOptionComponentProps).toneOptionType} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneOptionComponentProps).toneDto} context={this.getUIProps().context}/>);
    }
    private onAddToWishlistClicked(): void
    {
        (this.getUIComponentHandler() as ToneOptionComponentHandler).addToWishlist();
    }

    private onGiftToneClicked(): void 
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <GiftAFriendComponent showPopup={()=>''} toneOptionsType={(this.getUIProps() as ToneOptionComponentProps).toneOptionType} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneOptionComponentProps).toneDto} context={this.getUIProps().context}/>);
    }

    private onShareToneClicked(): void 
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <ShareToneComponent toneOptionsType={(this.getUIProps() as ToneOptionComponentProps).toneOptionType} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneOptionComponentProps).toneDto} context={this.getUIProps().context}/>);
    }

    private onReferToneClicked(): void 
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <TellAFriendComponent showPopup={()=>''} toneOptionsType={(this.getUIProps() as ToneOptionComponentProps).toneOptionType} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneOptionComponentProps).toneDto} context={this.getUIProps().context}/>);
    }

    private closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/toneoption/toneoptionview.tsx